import { deobfuscate } from './deobfuscate.js';

const executeDeobfuscate = (target) => {
  if (target.classList.contains('href-hidden')) {
    deobfuscate(target);
  }
};

export function initObserverDeobfuscation() {
  const observerOptions = {
    root: null,
    rootMargin: '50px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        executeDeobfuscate(entry.target);
        // Stop observing this element once processed
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const obfuscatedEntries = document.querySelectorAll('.href-hidden');

  obfuscatedEntries.forEach((obfuscatedEntry) => {
    if (obfuscatedEntry.dataset.hiddenInstantLoad === 'true') {
      // Deobfuscate immediately for instant load elements
      executeDeobfuscate(obfuscatedEntry);
    } else {
      // Use intersection observer for others
      observer.observe(obfuscatedEntry);
    }
  });

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the node itself has the obfuscated class
          if (node.classList && node.classList.contains('href-hidden')) {
            if (node.dataset.hiddenInstantLoad === 'true') {
              executeDeobfuscate(node);
            } else {
              observer.observe(node);
            }
          }

          // Check for obfuscated links within the added node
          const obfuscatedLinks = node.querySelectorAll && node.querySelectorAll('.href-hidden');
          if (obfuscatedLinks) {
            obfuscatedLinks.forEach((link) => {
              if (link.dataset.hiddenInstantLoad === 'true') {
                executeDeobfuscate(link);
              } else {
                observer.observe(link);
              }
            });
          }
        }
      });
    });
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initObserverDeobfuscation);
} else {
  initObserverDeobfuscation();
}
